/*
 * Copyright (c) 2026
 */
import { useCallback, useEffect, useRef, useState } from 'react'
import { HolidayPortal } from '../holiday-portal'
import { attachFogEffect } from './fog-webgl'

const FogEffect = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const [canvasMounted, setCanvasMounted] = useState(false)

  const setCanvasRef = useCallback((node: HTMLCanvasElement | null) => {
    canvasRef.current = node
    setCanvasMounted(node !== null)
  }, [])

  useEffect(() => {
    if (!canvasMounted) {
      return
    }
    const canvas = canvasRef.current
    if (!canvas) {
      return
    }
    return attachFogEffect(canvas)
  }, [canvasMounted])

  return (
    <HolidayPortal>
      <canvas
        aria-hidden
        className="pointer-events-none fixed inset-0 z-max h-screen w-screen opacity-100 lg:opacity-70"
        ref={setCanvasRef}
      />
    </HolidayPortal>
  )
}

export default FogEffect
